export const PRICING_RULE_SET_CLASSIFICATION_COLUMNS = [
  'requestingPlatformCode',
  'externalRiskClassification',
  'externalRiskClassificationMonthlyRateAdjustment',
];

export const PRICING_RULE_SET_COLUMNS_WITHOUT_CLASSIFICATION = [
  'requestingPlatformCode',
  'segmentDescription',
  'segmentMonthlyRateAdjustment',
  'segmentDefaultRateAdjustment',
  'minimumAmount',
  'maximumAmount',
  'amountRangeMonthlyRateAdjustment',
  'amountRangeDefaultRateAdjustment',
  'minimumDays',
  'maximumDays',
  'daysRangeMonthlyRateAdjustment',
  'daysRangeDefaultRateAdjustment',
];
